const BASE_URL = import.meta.env.REACT_APP_BASE_URL;

const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};
const userProfilePromiseCache = new Map();
const userProfileDataCache = new Map();

async function apiRequest(endpoint, method = "GET", body = null, queryParams = {}) {
  const config = {
    method,
    headers: DEFAULT_HEADERS,
  };
  if (body) {
    config.body = JSON.stringify(body);
  }

  let url = `${BASE_URL}/${endpoint}`;
  const queryString = new URLSearchParams(queryParams).toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  const response = await fetch(url, config);
  if (!response.ok) {
    console.log(`salesforceServiceAPI call failed: ${method} ${endpoint}`);
    throw new Error("Failed to proccess request, Please try again or contact Admin");
  }

  const textResponse = await response.text();
  try {
    return JSON.parse(textResponse);
  } catch {
    console.error("salesforceServiceAPI-Failed to parse JSON response:", textResponse);
    return {
      success: false,
      message: "Failed to parse salesforceServiceAPI response",
    };
  }
}

// Salesforce API Service
// Implement methods here as you migrate from Dataverse
// Methods not implemented here will automatically fall back to Dataverse
export const apiService = {
  // Add your Salesforce implementations here as you migrate them
  // getContact: (emailaddress1) => {
  //   //checkout and billingInfo
  //   return apiRequest("SalesforceContactsApi", "GET", null, { emailaddress1 });
  // },
  // getChildContacts: (parentContactId) => {
  //     // for ManageUSers
  //  // console.log("Fetching child contacts for parent:", parentContactId);
  //   return apiRequest("SalesforceContactsApi", "GET", null, { parentContactId });
  // },
  // getUserProfile: async (email) => {
  //   //B2C
  //   return apiRequest("SalesforceSubscriptionsApi", "GET", null, { email });
  // },
  getUserProfile: async (email, returnAll = true, { forceRefresh = false } = {}) => {
    const cacheKey = JSON.stringify({ email, returnAll });

    if (!forceRefresh && userProfileDataCache.has(cacheKey)) {
      return userProfileDataCache.get(cacheKey);
    }

    if (!forceRefresh && userProfilePromiseCache.has(cacheKey)) {
      return userProfilePromiseCache.get(cacheKey);
    }

    const request = apiRequest("SalesforceSubscriptionsApi", "GET", null, {
      email,
      returnAll,
    })
      .then((response) => {
        userProfileDataCache.set(cacheKey, response);
        userProfilePromiseCache.delete(cacheKey);
        return response;
      })
      .catch((error) => {
        userProfilePromiseCache.delete(cacheKey);
        throw error;
      });

    userProfilePromiseCache.set(cacheKey, request);
    return request;
  },

  clearUserProfileCache: (email) => {
    if (!email) {
      userProfilePromiseCache.clear();
      userProfileDataCache.clear();
      return;
    }

    for (const key of [...userProfilePromiseCache.keys()]) {
      if (key.includes(`"email":"${email}"`)) {
        userProfilePromiseCache.delete(key);
      }
    }

    for (const key of [...userProfileDataCache.keys()]) {
      if (key.includes(`"email":"${email}"`)) {
        userProfileDataCache.delete(key);
      }
    }
  },
  getReqInfo: async (ipNumber, ipString, referer, oaid, ipType) => {
    return apiRequest("SalesforceGetReqInfo", "GET", null, {
      ipNumber,
      ipString,
      r: referer,
      o: oaid,
      ipType,
    });
  },
  getInstitutionApi: (instSubscriptionId) => {
    // getInstitutionStatus expired true or false
    return apiRequest("SalesforceGetInstitutionApi", "GET", null, {
      instSubscriptionId,
    });
  },
  updateSubscription: async ({ subscriptionId, isCancel, cancelContext }) => {
    return apiRequest("SalesforceSubscriptionsApi", "PATCH", {
      subscriptionId,
      isCancel,
      cancelContext,
    });
  },
  getChildContacts: (InstitutionIdOfMU) => {
    return apiRequest("SalesforceAppIdentifierApi", "GET", null, {
      institutionSubscriptionIdMU: InstitutionIdOfMU,
    });

    // return apiRequest("SalesforceAccountApi", "GET", null, { accountId });
  },
  // updateChildUserStatus: (relationId, isActive) => {
  //   // inactivate contact
  //   return apiRequest("SalesforceAccountApi", "PATCH", {
  //     relationId,
  //     isActive,
  //   });
  // },
  createOrUpdateMultiuser: (contactData, subscription) => {
    return apiRequest("SalesforceContactsApi", "POST", {
      contactData, // FirstName, LastName, Email, Phone, s_c__Username__c, AccountId
      subscription,
    });
  },
  deleteAppIdentifier: (appIdentifierId) => {
    return apiRequest("SalesforceAppIdentifierApi", "DELETE", null, {
      appIdentifierId,
    });
  },
  getInstitutionEnquiryById: (recordId, isSalesforceEnabled = false) => {
    return apiRequest("LeadEnquiryApi", "GET", null, { recordId, isSalesforceEnabled }); // cause mapping is used of dataverse
  },
  //Use PUT for full replacement or create-if-not-exists.
  createOrUpdateInstitutionEnquiry: (data, recordId = null, isSalesforceEnabled = false) => {
    return apiRequest("LeadEnquiryApi", "PUT", { ...data, isSalesforceEnabled, recordId }); // cause mapping is used of dataverse
  },
  //   createChildUser: (NewContact, subscriptionData, licensesData) => {

  //   return apiRequest("ManageUser", "POST", {
  //     NewContact,
  //     subscriptionData,
  //   });
  // },
  // mainAccountSubscirbeMyself: (contactId, flags, subscriptionData) => { // it done with updateChildUserStatus
  //   return apiRequest("ManageUser", "PUT", {
  //     contactId: contactId,
  //     flags,
  //     subscriptionData,
  //   });
  // },
};
